import { useEffect } from 'react';

// eslint-disable-next-line react-hooks/exhaustive-deps
const useEffectOnce = (effect) => useEffect(effect, []);

export default useEffectOnce;
